<script lang="ts">
  let {
    value,
  }: {
    value: unknown
  } = $props()

  const original = $derived(String(value ?? ''))
  const displayValue = $derived(formatDate(original))

  function formatDate(input: string): string {
    const dateOnlyMatch = /^(\d{4})-(\d{2})-(\d{2})$/.exec(input)
    const parsed = dateOnlyMatch
      ? new Date(Number(dateOnlyMatch[1]), Number(dateOnlyMatch[2]) - 1, Number(dateOnlyMatch[3]))
      : new Date(input)

    if (Number.isNaN(parsed.getTime())) {
      return input
    }

    return new Intl.DateTimeFormat(undefined, {
      year: 'numeric',
      month: 'short',
      day: 'numeric',
    }).format(parsed)
  }
</script>

<span class="widget-date" title={original}>{displayValue}</span>
